import { AuthService } from './../../../../../services/auth/auth.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Translators } from './../../../../../services/shared/translators.service';
import { Subscription } from 'rxjs';
import { PopUpModalCustomService } from '@services/shared/popup-modal-custom.service';

@Component({
  selector: 'app-modal-modificar-clave',
  templateUrl: './modal-modificar-clave.component.html',
  styleUrls: ['./modal-modificar-clave.component.scss']
})
export class ModalModificarClaveComponent implements OnInit {

    form: FormGroup;
    idioma: Subscription;
    showPassword: boolean;
    showPasswordConfirm: boolean;

    isUpdatingPwd: boolean = false;

    constructor(
        private authService: AuthService,
        private translatorService: Translators,
        private popup: PopUpModalCustomService,
        /* Modal Ref. */
        public dialogRef: MatDialogRef<ModalModificarClaveComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string // los datos los recibo - en este caso no recibo data
        /* Fin Modal Ref. */
    ) {
        this.idioma = this.translatorService.getIdiomaSeleccionado().subscribe(resp => {
            this.idioma = resp;
          });

        this.createForm();
     }

    ngOnInit(): void {
    }

    /* Creacion de formulario */
    createForm() {
        this.form = new FormGroup({
        password: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]),
        confirmPassword: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]),
    });
    }

    /* Cerrar modal */
    closeModal(): void {
        // Solo permitir cerrar si no está procesando
        if (!this.isUpdatingPwd) {
            this.dialogRef.close(this.data);
        }
    }

    /* Modificar pwd*/
    async put(){
        if (this.form.invalid){
            return Object.values( this.form.controls ).forEach( control => {
                control.markAsTouched();
            });
        }

        if (this.form.value.password !== this.form.value.confirmPassword) {
            this.popup.abrirPopup({
                tipo: 'error',
                titulo: 'Las contraseñas no coinciden',
                mensaje: 'Verificá que ambas contraseñas sean iguales e intentá nuevamente.',
            });
            return;
        }

        this.isUpdatingPwd = true;

        try {
            await this.authService.newPassword(
                this.form.value.password,
                this.form.value.confirmPassword
            );

            // Cerrar el modal directamente (sin pasar por closeModal)
            this.dialogRef.close(this.data);

            this.popup.abrirPopup({
                tipo: 'success',
                titulo: 'Contraseña modificada',
                mensaje: 'Tu contraseña se actualizó correctamente.',
                tiempoAutoCierre: 2200,
            });

        } catch (error) {
            console.error('Error al cambiar contraseña:', error);
            this.popup.abrirPopup({
                tipo: 'error',
                titulo: 'No se pudo modificar',
                mensaje: 'No se pudo modificar la contraseña. Intentá nuevamente.',
            });
        } finally {
            this.isUpdatingPwd = false;
        }
    }

    /* Validaciones */
    get passwordNoValido(){
        return this.form.get('password').invalid && this.form.get('password').touched;
    }

    get confirmPasswordNoValido(){
        const pass1 = this.form.get('password').value;
        const pass2 = this.form.get('confirmPassword').value;
        return ( pass1 === pass2 ) ? false : true;
    }

}
